import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { RouteProps } from 'react-router-dom';
import classNames from 'classnames';
import Image, { ImageType } from '../../../components/image/image';
import messages from '../messages';

const Ready: React.SFC<RouteProps> = props => (
  <div
    className="o-flex o-flex--wrap o-flex--justify-center"
    style={{ width: '100%' }}
  >
    <p className={classNames('c-bubble__content c-bubble__content-left')}>
      <FormattedHTMLMessage {...messages.ready} />
    </p>

    <Image
      imgSrc="/images/svg/fitting-space-suit.svg"
      alt="Progress"
      type={ImageType.fittingSuit}
    />
  </div>
);

export default Ready;



// WEBPACK FOOTER //
// ./src/containers/fitting/components/Ready.tsx